import ResourceLinkField from './component';
import { ResourceLinkFieldProps } from './types';

export default ResourceLinkField;
export type { ResourceLinkFieldProps };
